module.exports = __webpack_public_path__ + "static/media/metricpopup_logo_programmaticplatform.38b63257.png";